// extracted by mini-css-extract-plugin
export default {"DropdownMenu":"DropdownMenu_DropdownMenu__poG+n","DropdownMenuItem":"DropdownMenu_DropdownMenuItem__fFGdl"};